import { render, staticRenderFns } from "./imagenes.vue?vue&type=template&id=da38095c&"
import script from "./imagenes.vue?vue&type=script&lang=js&"
export * from "./imagenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports